<a
  class="btn btn-sm d-inline-flex align-items-center"
  [ngClass]="btnClass ? btnClass : 'btn-outline-bitbucket'"
  [ngStyle]="btnStyle"
  (click)="instalar()"
  [title]="label || texto || 'Instalar aplicación'"
>
  <i-feather
    name="download"
    [class.mr-1]="label || texto"
    style="width:14px;height:14px">
  </i-feather>
  <span *ngIf="label || texto" class="small font-weight-bold">{{ label || texto }}</span>
</a>
